import { useState, useEffect } from 'react';

/**
 * Hook customizado para persistir estado no localStorage
 *
 * @param {string} key - Chave no localStorage
 * @param {any} initialValue - Valor inicial se não houver nada salvo
 * @returns {[any, function]} - [valor, setValor]
 *
 * @example
 * const [dreData, setDreData] = useLocalStorage('dreData', null);
 */
function useLocalStorage(key, initialValue) {
  // Inicializar estado com valor do localStorage ou valor inicial
  const [storedValue, setStoredValue] = useState(() => {
    if (typeof window === 'undefined') {
      return initialValue;
    }

    try {
      const item = window.localStorage.getItem(key);

      // Parse JSON se existir, senão retorna valor inicial
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.error(`Erro ao ler localStorage key "${key}":`, error);
      return initialValue;
    }
  });

  // Atualizar localStorage sempre que o valor mudar
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    try {
      // Salvar no localStorage
      if (storedValue === null || storedValue === undefined) {
        window.localStorage.removeItem(key);
      } else {
        window.localStorage.setItem(key, JSON.stringify(storedValue));
      }
    } catch (error) {
      console.error(`Erro ao salvar localStorage key "${key}":`, error);
    }
  }, [key, storedValue]);

  return [storedValue, setStoredValue];
}

export default useLocalStorage;
